/*===================================================
custom javascript for Omni Brass
===================================================*/
$(function () {

	

	$(window).scroll(function () {
		if ($(this).scrollTop()) {
			$('#back-top').fadeIn();
		} else {
			$('#back-top').fadeOut();
		}
	});

	$("#back-top").click(function () {
		//1 second of animation time
		//html works for FFX but not Chrome
		//body works for Chrome but not FFX
		//This strange selector seems to work universally
		$("html, body").animate({ scrollTop: 0 }, 1500);
	});


	$('.search-box a.search-icon').click(function(){
		$('.search-form-top').addClass('open');
		});
		$('a.close-search').click(function(){
		$('.search-form-top').removeClass('open');
	});
  
   
  $('#accordion .collapse a').attr('target', '_blank');
 
  
  
$('[data-toggle="tooltip"]').tooltip();

});

// When the user scrolls the page, execute heroCaptionHide
// When the user scrolls the page, execute myFunction
window.onscroll = function () {
	myFunction();
};


// Get the header
var header = document.getElementById("myHeader");
// Get the offset position of the navbar
var stickyHeader = header.offsetTop;
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
	if (window.pageYOffset > 0) {
		header.classList.add("sticky");
	} else {
		header.classList.remove("sticky");
	}
}

 
